import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { reelsSharesConfig } from '../reelsShares';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsSharesMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    ...reelsSharesConfig,
    name: 'kpi.facebook.shares',
    id: 'shares',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
